import { PropsWithChildren } from 'react';

interface NeoLeoBodyWrapperProps extends PropsWithChildren<{}> {
  isFirst?: boolean;
  isLast?: boolean;
}

export const NeoLeoBodyWrapper: React.FC<NeoLeoBodyWrapperProps> = ({
  children,
}) => (
  <div className='w-full h-full flex flex-col font-inter bg-reskin-primary-navy overflow-hidden scrollbar-hide'>
    {children}
  </div>
);
